import { getApiClient } from '../client';
import { handleApiError } from '../utils/handleApiError';
import type {
  ServiceResponse,
  SummaryAgentResponse,
} from '@dopomogai/types';

type UpdateSummaryAgentPayload = Partial<Pick<SummaryAgentResponse, 'prompt_content' | 'model_descriptor'>>;

export const summaryAgentService = {
  getSummaryAgent: (): ServiceResponse<SummaryAgentResponse> => {
    return getApiClient()
      .get<SummaryAgentResponse>('/summary-agent')
      .then(response => response.data)
      .catch(err => handleApiError(err, 'fetching summary agent settings'));
  },

  updateSummaryAgent: (payload: UpdateSummaryAgentPayload): ServiceResponse<SummaryAgentResponse> => {
    return getApiClient()
      .patch<SummaryAgentResponse>('/summary-agent', payload)
      .then(response => response.data)
      .catch(err => handleApiError(err, 'updating summary agent settings'));
  },

  resetSummaryAgent: (): ServiceResponse<SummaryAgentResponse> => {
    return getApiClient()
      .post<SummaryAgentResponse>('/summary-agent/reset')
      .then(response => response.data)
      .catch(err => handleApiError(err, 'resetting summary agent settings'));
  },
};